import { MatSidenav } from '@angular/material/sidenav';
import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { LandingAuthBoxService } from './services/landing-auth-box.service';
import { RegisterModalComponent } from 'src/app/feature/landing/components/register-modal/register-modal.component';
import { Router } from '@angular/router';
import { SubSink } from 'subsink';
import { Meta } from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material/snack-bar';
import { map, Observable, shareReplay, timeout } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { landingAnimations } from './animation';
import { AuthStatusObject, Order, OrderTypes } from 'src/app/shared';
import {
  AuthService,
  IS_SERVER_PLATFORM,
  UserRoles,
  UserSchema,
  UserService,
  XeroxMessages,
} from 'src/app/core';
import { OrderService, ResponsiveService, TitleService } from '../services';
import { OrderActionHandlerService } from '../payment/services/order-action-handler.service';
import { LogoAnimationComponent } from '../components';
import { ComponentBusService } from './services/component-bus.service';
import { DataSharingService } from 'src/app/shared/services/data-sharing.service';
import { config } from '../../../../config/config';
import { MatDialog } from '@angular/material/dialog';
import { ScrollStrategy, ScrollStrategyOptions } from '@angular/cdk/overlay';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  animations: [landingAnimations],
})
export class LandingComponent implements OnInit, AfterViewInit {
  @ViewChild('sidenav') sidenav!: MatSidenav;

  @ViewChild('mainLogoAnimation')
  mainLogoAnimation!: LogoAnimationComponent;

  @ViewChild('landingContainer') landingContainer: any;

  public isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );

  private subsink = new SubSink();
  public logoAnimationHeight!: number;

  public selectedIndex = 0;
  public sidenavPart!: string;
  public orders: Order[] = [];
  public loading: boolean = true;
  public includeHeaderStuff: boolean = false;

  public userData!: UserSchema;
  public userRoles = UserRoles;
  public isUserActivated!: boolean;
  public isAuthenticated: boolean = true;
  public navigationLoadingState: boolean = false;

  public config: any = null;
  // openReferralTimeout: any;
  scrollStrategy: ScrollStrategy;
  constructor(
    private breakpointObserver: BreakpointObserver,
    private authBoxService: LandingAuthBoxService,
    public orderAction: OrderActionHandlerService,
    private busService: ComponentBusService,
    private ordersService: OrderService,
    private userService: UserService,
    private authService: AuthService,
    private snackbar: MatSnackBar,
    public router: Router,
    private titleService: TitleService,
    private metaService: Meta,
    private responsiveService: ResponsiveService,
    private dialogBox: MatDialog,
    private readonly sso: ScrollStrategyOptions,
    @Inject(IS_SERVER_PLATFORM) private isServer: boolean
  ) {
    this.scrollStrategy = this.sso.reposition();
    this.isAuthenticated = false;
    this.orders = [];

    // this.subsink.sink = this.titleService.pointerSubject$.subscribe(
    //   (pointer) => {
    //     if (pointer?.length) {
    //       this.config = config[pointer];
    //     } else {
    //       this.config = null;
    //     }
    //   }
    // );

    this.router.events.subscribe(event => {
      let url = this.router.url;
        if (url.includes('black-and-white-print')) {
          this.config = config['blackAndWhitePrint'];
          this.titleService.setTitle("پرینت سیاه‌ و سفید + تخفیفات پلکانی");
          this.titleService.updatePageDescription("پرینت سیاه ‌و سفید ارزان و باکیفیت را در سامانه چاپ آنلاین زیراکسی تجربه کنید، از تخفیفات پلکانی بهره‌مند شوید و با روش‌های متنوع ارسال خود را رایگان کنید.");
        } else if (url.includes('half-color-print')) {
          this.config = config['halfColorPrint'];
          this.titleService.setTitle("پرینت رنگی ارزان با تضمین کیفیت + ارسال فوری");
          this.titleService.updatePageDescription("پرینت رنگی ارزان و باکیفیت را در معتبرترین سامانه چاپ آنلاین کشور تجربه کنید و در کمترین بازه زمانی ممکن سفارش خود را دریافت کنید.");
        } else if (url.includes('combined-printing')) {
          this.config = config['mixedPrint'];
          this.titleService.setTitle("ترکیبی از پرینت سیاه ‌و سفید و رنگی");
          this.titleService.updatePageDescription("در زیراکسی می‌توانید برخی از صفحات جزوه و یا کتاب خود را سیاه ‌و سفید برخی دیگر را رنگی پرینت کنید و هزینه‌های خود صرفه جویی کنید.");
        } else if (url.includes('full-color-print')) {
          this.config = config['colorfulPrint'];
          this.titleService.setTitle("پرینت رنگی آنلاین با تضمین کیفیت");
          this.titleService.updatePageDescription("پرینت رنگی و دیگر خدمات زیراکسی دارای تضمین کیفیت است و در صورت نارضایتی مشتری هزینه عودت می‌شود. همین حالا ثبت سفارش کنید و از تخفیفات پلکانی بهره‌مند شوید.");
        } else if (url.includes('online-print')) {
          this.config = config['onlinePrint'];
          this.titleService.setTitle("پرینت آنلاین و ارزان + ارسال رایگان");
          this.titleService.updatePageDescription("در زیراکسی می‌توانید با روش‌های مختلف ارسال رایگان داشته باشید و با تخفیفات پلکانی در هزینه‌های خود صرفه‌جویی کنید.");
        } else if (url.includes('cheap-print')) {
          this.config = config['cheapPrint'];
          this.titleService.setTitle("پرینت ارزان + تخفیفات پلکانی");
          this.titleService.updatePageDescription("پرینت ارزان و باکیفیت را در زیراکسی تجربه کنید. با تخفیفات پلکانی تا 80 درصد در هزینه‌های خود صرفه‌جویی کنید و به روش‌های مختلف ارسال خود را رایگان کنید.");
        } else if (url.includes('booklet-print')) {
          this.config = config['bookletPrint'];
          this.titleService.setTitle("چاپ جزوه آنلاین، ارزان و فوری");
          this.titleService.updatePageDescription("با تخفیفات پلکانی زیراکسی تا 90 درصد در هزینه‌های خود صرفه‌جویی کنید و چاپ جزوه آنلاین و با کیفیت را تجربه کنید.");
        } else if (url.includes('thesis-binding')) {
          this.config = config['ThesisOrder'];
          this.titleService.setTitle("پرینت و صحافی پایان نامه ارزان و با کیفیت + ارسال سریع");
          this.titleService.updatePageDescription("در زیراکسی پرینت و صحافی پایان نامه را در بالاترین کیفیت و دقت تجربه کنید و در هزینه و زمان خود صرفه جویی کنید");
        } else if (url.includes('thesis-editing')) {
          this.config = config['ThesisEditOrder'];
          this.titleService.setTitle("ویرایش پایان نامه در بالاترین کیفیت");
          this.titleService.updatePageDescription("در زیراکسی ویرایش پایان نامه توسط متخصصین با تجربه در بالاترین کیفیت و دقت ممکن انجام می‌شود. ویرایش پایان نامه خود را با خیال راحت به ما بسپارید.");
        } else {
          this.config = null;
          this.titleService.setDefaultTitle();
          this.titleService.updatePageDescription('بالاترین کیفیت و کمترین قیمت پرینت سیاه و سفید را در زیراکسی تجربه کنید و با تخفیفات پلکانی در هزینه‌های خود صرفه‌جویی کنید.ارسال بالای 2 میلیون رایگان');
        }
    });
  }

  ngAfterViewInit(): void {
    // this.subsink.sink = this.userService.getUserNotifications().subscribe();
    // uncomment this part to get user notifications
    // this.subsink.sink = this.userService
    // .getUserNotifications()
    // .subscribe((notifications) => {
    //   this.notifications = notifications;
    // });
    // if (!this.isServer) {
    //   clearTimeout(this.openReferralTimeout);
    //   this.openReferralTimeout = setTimeout(() => {
    //     if (!this.userData.id) {
    //       this.dialogBox
    //         .open(RegisterModalComponent, {
    //           width: '450px',
    //           minHeight: '500px',
    //           minWidth: '50% !important',
    //           // scrollStrategy: this.scrollStrategy,
    //         })
    //         .afterClosed()
    //         .subscribe((result) => {
    //           if (result === 'register') this.authService.openAuthBox();
    //         });
    //     }
    //   }, 10000);
    // }
  }

  public get isMobile(): Observable<boolean> {
    return this.responsiveService.isMobileScreen$;
  }
  public get isTablet(): Observable<boolean> {
    return this.responsiveService.isTablet$;
  }

  ngOnInit() {
    this.subsink.sink = this.authBoxService.action$.subscribe({
      next: (data) => {
        this.authService.checkOrOpenAuthBox();
      },
    });

    this.busService.events$.subscribe({
      next: ({ context }) => {
        if (context === 'order-add') {
          this.ordersService.getEveryUserOrder().then((orders) => {
            this.orders = orders;
          });
        }

        if (context === 'order-reset') {
          window.scrollBy(0, 1);
        }
      },
    });

    this.breakpointObserver
      .observe(Breakpoints.Medium)
      .pipe(map((result) => result.matches))
      .subscribe({
        next: (result) => {
          if (this.mainLogoAnimation) this.mainLogoAnimation.updateAndRun(1250);
        },
      });

    // this.subsink.sink = this.userService.getUser$().subscribe((user) => {
    //   this.userData = user;
    // });

    this.subsink.sink = this.authService.userProfile.subscribe({
      next: (user) => {
        this.userData = user;
      },
    });

    this.subsink.sink = this.authService.authStatus.subscribe((status) => {
      if (
        status?.type === 'login' ||
        status?.type === 'google-auth' ||
        (status?.type === 'registration' && status?.data)
      ) {
        this.onAuthentication(status);
      }
    });
  }

  // Methods -------------------------------------
  public scrollToLandingOutlet() {
    let el = document.getElementById('serviceTitleWrapper');
    setTimeout(() => {
      el?.scrollIntoView({behavior: 'smooth'});
    }, 10);
    // const scrollTimeMS = 1000;

    // this.isHandset$.subscribe({
    //   next: (result) => {
    //     if (result) {
    //       this.scrollToSmoothly(
    //         this.landingContainer.nativeElement.offsetTop - 70,
    //         scrollTimeMS
    //       );
    //     } else {
    //       this.scrollToSmoothly(
    //         this.landingContainer.nativeElement.offsetTop,
    //         scrollTimeMS
    //       );
    //     }
    //   },
    // });
  }

  scrollToSmoothly(pos: number, time: number) {
    var currentPos = window.pageYOffset;
    var start: any = null;
    if (time == null) time = 500;
    (pos = +pos), (time = +time);
    window.requestAnimationFrame(function step(currentTime) {
      start = !start ? currentTime : start;
      var progress = currentTime - start;
      if (currentPos < pos) {
        window.scrollTo(0, ((pos - currentPos) * progress) / time + currentPos);
      } else {
        window.scrollTo(0, currentPos - ((currentPos - pos) * progress) / time);
      }
      if (progress < time) {
        window.requestAnimationFrame(step);
      } else {
        window.scrollTo(0, pos);
      }
    });
  }

  public onAuthentication(authObject: AuthStatusObject) {
    if (!authObject) return;

    this.isAuthenticated = true;
    this.userService.refreshUser(authObject.data as UserSchema);
    this.openDefaultSnackbar(
      XeroxMessages.USER_AUTHORIZATION.success.SUCCESS_LOGIN
    );
  }

  public openDefaultSnackbar(message: string) {
    this.snackbar.open(message, 'باشه', { duration: 1500 });
  }

  // ------------------------------------Private methods|

  ngOnDestroy() {
    // clearTimeout(this.openReferralTimeout);
    this.subsink.unsubscribe();
    this.titleService.setPublicDescriptionTag();
  }
}
